import { SnackBarNotification } from '@dispatch/shared/types';
import { OptionsObject, useSnackbar, WithSnackbarProps } from 'notistack';
import React from 'react';
import { Snackbar } from '../hooks/notification';

let snackbarRef: WithSnackbarProps;
export const SnackbarUtilsConfigurator: React.FC = () => {
  snackbarRef = useSnackbar();
  return null;
};

export const snackNotifications: SnackBarNotification = {
  success(title: string, msg: string, options: OptionsObject = {}): void {
    return this.toast(title, msg, { variant: 'success' });
  },
  warning(title: string, msg: string, options: OptionsObject = {}): void {
    return this.toast(title, msg, { ...options, variant: 'warning' });
  },
  info(title: string, msg: string, options: OptionsObject = {}): void {
    return this.toast(title, msg, { ...options, variant: 'info' });
  },
  error(title: string, msg: string, options: OptionsObject = {}): void {
    return this.toast(title, msg, {
      ...options,
      variant: 'error',
      preventDuplicate: true,
    });
  },
  toast(title: string, msg: string, options: OptionsObject = {}): void {
    snackbarRef.enqueueSnackbar(msg, {
      ...options,
      content: (key) => {
        return (
          <Snackbar
            id={key}
            title={title}
            message={msg}
            variant={options.variant || 'success'}
          />
        );
      },
    });
  },
};
